import React from "react";

function NXPayPal({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      width="15"
      height="15"
      viewBox="0 0 37.08 43.17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      stroke="currentColor"
      style={{ color: className ? undefined : "black" }}

    >
      <path
        d="M8.93,43.17c-.58-.37-.64-.53-.52-1.22.21-1.17.41-2.35.63-3.58-.18,0-.33,0-.48,0-2.5,0-5,0-7.5,0-.86,0-1.15-.36-1.03-1.22.62-4.36,1.23-8.72,1.84-13.08.66-4.69,1.33-9.39,1.99-14.08.43-3.03.85-6.06,1.28-9.08.09-.64.36-.87,1.01-.87,4.84,0,9.69-.08,14.53.02,5.33.1,9.16,2.68,11.41,7.5.81,1.74,1.13,3.61.96,5.54-.04.49.14.75.48,1.05,2.47,2.15,3.68,4.88,3.54,8.15-.14,3.11-1.52,5.62-3.95,7.54-1.95,1.54-4.21,2.24-6.69,2.23-2.12,0-4.24,0-6.36,0-.3,0-.4.07-.44.39-.46,3.29-.94,6.58-1.41,9.87-.06.4-.26.66-.59.86h-8.68ZM6.64,1.63c-1.65,11.72-3.29,23.41-4.94,35.12h7.57c.07-.48.13-.94.19-1.4.52-3.72,1.05-7.44,1.57-11.17.11-.76.34-.99,1.13-.99,2.77,0,5.53.02,8.3-.01.88-.01,1.78-.08,2.63-.28,3.07-.71,5.45-2.43,6.98-5.19,1.96-3.52,1.99-7.14-.02-10.63-2.09-3.64-5.37-5.43-9.57-5.45-4.45-.02-8.9,0-13.36,0-.15,0-.31,0-.49,0Zm10.04,39.92c.03-.17.06-.32.08-.47.46-3.21.92-6.42,1.38-9.62.12-.79.36-.99,1.18-.99,2.35,0,4.69.03,7.04-.01.88-.02,1.77-.1,2.62-.32,5.48-1.39,8.13-7.45,5.45-12.42-.44-.81-1-1.53-1.74-2.17-.07.23-.11.4-.18.57-.35.82-.63,1.69-1.09,2.45-2.48,4.11-6.15,6.18-10.94,6.23-2.47.03-4.94,0-7.42,0-.16,0-.33,0-.48,0-.81,5.62-1.61,11.18-2.41,16.76h6.5Z"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}

export default NXPayPal;
